// import React, { useContext } from "react";
// import { motion } from "framer-motion";
// import displayINRCurrency from "../helpers/displayCurrency";
// import { FaShoppingCart, FaArrowRight } from "react-icons/fa";
// import SummaryApi from "../common";
// import Context from "../context";
// import { useNavigate } from "react-router-dom";

// const VerticalCard = ({ data }) => {

//   const product = data[0];
//   const navigate = useNavigate();
//   const { fetchUserAddToCart } = useContext(Context);

//   // ✅ VARIANT BASED PRICE
//   const variant = product?.variants?.[0];
//   const price = Number(variant?.price || 0);

//   // ✅ ADD TO CART
//   const handleAddToCart = async (e) => {
//     e.stopPropagation(); // 🔥 VERY IMPORTANT

//     const response = await fetch(SummaryApi.addToCartProduct.url, {
//       method: SummaryApi.addToCartProduct.method,
//       credentials: "include",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({
//         productId: product?._id,
//         ram: variant?.ram,
//         storage: variant?.storage,
//         price: price
//       }),
//     });

//     const resData = await response.json();

//     if (resData.success) {
//       fetchUserAddToCart();
//       alert("Added to cart ✅");
//     }
//   };

//   // ✅ BUY NOW → GO TO PRODUCT DETAILS
//   const handleBuyNow = (e) => {
//     e.stopPropagation(); // 🔥 IMPORTANT
//     navigate(`/product/${product?._id}`);
//   };

//   return (
//     <motion.div
//       whileHover={{ y: -10 }}
//       onClick={() => navigate(`/product/${product?._id}`)} // 🔥 CARD CLICK
//       className="bg-white rounded-[30px] p-3 shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
//     >

//       {/* IMAGE */}
//       <img
//         src={product?.productImage?.[0]}
//         className="w-full h-64 object-cover rounded-[20px]"
//       />

//       {/* DETAILS */}
//       <div className="mt-4">

//         <h2 className="font-bold text-lg line-clamp-1">
//           {product?.productName}
//         </h2>

//         <p className="text-gray-500 text-sm">
//           {product?.brand}
//         </p>

//         {/* PRICE + BUTTONS */}
//         <div className="flex justify-between items-center mt-4">

//           <div className="bg-gray-100 px-4 py-2 rounded-full font-semibold">
//             {displayINRCurrency(price)}
//           </div>

//           <div className="flex gap-2">

//             {/* ADD TO CART */}
//             <button
//               onClick={handleAddToCart}
//               className="bg-black text-white p-3 rounded-full hover:bg-gray-800"
//             >
//               <FaShoppingCart />
//             </button>

//             {/* BUY NOW */}
//             <button
//               onClick={handleBuyNow}
//               className="bg-black text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-gray-800"
//             >
//               Buy <FaArrowRight className="text-xs" />
//             </button>

//           </div>

//         </div>

//       </div>

//     </motion.div>
//   );
// };

// export default VerticalCard;
import React, { useContext, useState } from "react";
import { motion } from "framer-motion";
import displayINRCurrency from "../helpers/displayCurrency";
import { FaShoppingCart, FaHeart, FaStar } from "react-icons/fa";
import SummaryApi from "../common";
import Context from "../context";
import { useNavigate } from "react-router-dom";

const VerticalCard = ({ data }) => {

  const product = data[0]; // same rakha
  const navigate = useNavigate();
  const { fetchUserAddToCart } = useContext(Context);

  const [wish, setWish] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const variant = product?.variants?.[0];
  const price = Number(variant?.price || 0);

  // ✅ ADD TO CART
  const handleAddToCart = async (e) => {
    e.stopPropagation();

    if (!product?._id) {
      console.log("Product ID missing ❌");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(SummaryApi.addToCartProduct.url, {
        method: SummaryApi.addToCartProduct.method,
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          productId: product._id,
          ram: variant?.ram,
          storage: variant?.storage,
          price: price
        }),
      });

      const data = await res.json();

      if (data.success) {
        fetchUserAddToCart();
      }

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ BUY NOW FIX
  const handleBuyNow = (e) => {
    e.stopPropagation();
    navigate(`/product/${product?._id}`);
  };

  return (
  <motion.div
  whileHover={{ y: -6 }}
  onClick={() => navigate(`/product/${product?._id}`)}
  className="bg-white/80 backdrop-blur-sm rounded-2xl 
  shadow-md hover:shadow-xl transition cursor-pointer 
  w-full max-w-[260px] sm:max-w-[300px]"
>

  {/* IMAGE */}
  <div
    className="relative bg-gray-100/60 p-3 sm:p-4"
    onMouseEnter={() => setImgIndex(1)}
    onMouseLeave={() => setImgIndex(0)}
  >
    <img
      src={product?.productImage?.[imgIndex] || product?.productImage?.[0]}
      className="h-32 sm:h-40 md:h-48 mx-auto object-contain transition duration-300 group-hover:scale-105"
    />

    {/* ❤️ WISHLIST */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        setWish(!wish);
      }}
      className="absolute top-2 right-2 bg-white/80 backdrop-blur 
      p-2 rounded-full shadow hover:scale-110 transition"
    >
      <FaHeart className={wish ? "text-red-500" : "text-gray-400"} />
    </button>
  </div>

  {/* DETAILS */}
  <div className="p-3 sm:p-4">

    {/* TOP */}
    <div className="flex justify-between items-center mb-1">
      <span className="bg-yellow-400/90 text-[10px] px-2 py-[2px] rounded">
        New
      </span>

      <span className="flex items-center gap-1 text-xs text-gray-600">
        <FaStar className="text-yellow-400 text-[12px]" /> 4.5
      </span>
    </div>

    {/* TITLE */}
    <h2 className="font-medium text-xs sm:text-sm line-clamp-1">
      {product?.productName}
    </h2>

    <p className="text-[10px] sm:text-xs text-gray-500 mt-1">
      {product?.brand}
    </p>

    {/* PRICE */}
    <div className="mt-2">
      <p className="font-semibold text-sm sm:text-base">
        {displayINRCurrency(price)}
      </p>

      <p className="text-[10px] text-gray-400 line-through">
        {displayINRCurrency(price + 2000)}
      </p>
    </div>

    {/* BUTTON */}
    <div className="mt-3">
      <button
        onClick={handleBuyNow}
        className="w-full bg-black text-white py-2 rounded-lg 
        text-xs hover:bg-gray-800 transition"
      >
        View Product
      </button>
    </div>

  </div>
</motion.div>
  );
};

export default VerticalCard;